import React from "react";
import {
  decorateComponentWithProps,
  PLUGIN_TOOLBAR_BUTTON_ID
} from "./../editor-common";
import {
  getVisibleOnlyOnDesktopResolver,
  selectedNodeResolver,
  Uploader
} from "./../plugin-commons";
import {
  AlignmentPanel,
  NodeAlignmentButton,
  NodeSizeButton,
  SizePanel
} from "./../toolbars-ui";
import { AUDIO_BUTTONS, audioModals } from "./consts";
import { InsertModal } from "./modals/InsertModal";
import { AudioSettingsModal } from "./modals/SettingsModal";
import AudioEditButton from "./toolbar/AudioEditButton";
import { AudioPluginService } from "./toolbar/audioPluginService";
import { AUDIO_TYPE } from "./types";
const isCustomAudioResolver = {
  id: "isCustomAudio",
  resolve: (content) => {
    if (Array.isArray(content) && content.length > 0) {
      return !!content[0].attrs?.audio?.src?.id;
    } else {
      return false;
    }
  }
};
const audioPluginService = new AudioPluginService();
const isValidIndex = (index) => typeof index === "number" && index >= 0;
const getToolbarButtons = (config, services) => {
  const {
    modals,
    context: { isMobile }
  } = services;
  const handleOnFileSelect = (uploadService, updateService, node, index) => {
    const fileState = isValidIndex(index) ? { itemIndex: index } : void 0;
    if (config?.handleFileSelection) {
      return config.handleFileSelection(
        ({ data }) => {
          const file = Array.isArray(data) ? data[0] : data;
          updateService.updatePluginData(
            { data: file },
            node.attrs.id,
            AUDIO_TYPE,
            audioPluginService,
            fileState
          );
        },
        void 0,
        true,
        {}
      );
    }
    if (config?.handleFileUpload) {
      uploadService.selectFiles("image/*", false, (files) => {
        uploadService.uploadFile(
          files[0],
          node.attrs.id,
          new Uploader(config?.handleFileUpload),
          AUDIO_TYPE,
          audioPluginService,
          fileState
        );
      });
    }
  };
  return [
    {
      id: audioModals.settings,
      dataHook: "baseToolbarButton_settings",
      modal: {
        Component: AudioSettingsModal,
        id: audioModals.settings
      },
      attributes: {
        visible: isCustomAudioResolver,
        selectedNode: selectedNodeResolver
      },
      command: ({ isMobile: isMobile2, referenceElement, attributes: { selectedNode } }) => {
        const { uploadService, updateService } = services;
        const componentProps = {
          nodeId: selectedNode.attrs.id,
          onFileSelect: (index) => {
            if (uploadService && updateService) {
              handleOnFileSelect(uploadService, updateService, selectedNode, index);
            }
          }
        };
        modals?.openModal({
          id: audioModals.settings,
          Component: AudioSettingsModal,
          componentProps,
          withTransition: true,
          noPadding: true,
          type: "exclusive",
          layout: isMobile2 ? "fullscreen" : "floating",
          positioning: {
            referenceElement: referenceElement?.closest("[data-hook~=floating-plugin-toolbar]") ?? referenceElement,
            placement: "right-start"
          },
          enableDrag: !isMobile2,
          dragHandleSelector: "[data-drag-handler]"
        });
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(AudioEditButton, { toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: isCustomAudioResolver,
        selectedNode: selectedNodeResolver
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SIZE,
      modal: {
        Component: decorateComponentWithProps(SizePanel, {
          options: ["SMALL", "CONTENT"]
        }),
        id: AUDIO_BUTTONS.size
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeSizeButton, { id: AUDIO_BUTTONS.size, toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT,
      modal: {
        Component: AlignmentPanel,
        id: AUDIO_BUTTONS.alignment
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeAlignmentButton, { toolbarItem, id: AUDIO_BUTTONS.alignment })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.REPLACE,
      modal: {
        Component: InsertModal,
        id: audioModals.replace
      },
      attributes: {
        active: {
          id: "IS_AUDIO_REPLACE_BUTTON_ACTIVE",
          resolve: (_, { modals: modals2 }) => Boolean(modals2.getModal(audioModals.replace))
        }
      },
      command: ({ isMobile: isMobile2, referenceElement, attributes: { selectedNode } }) => {
        const {
          audio: { src },
          id
        } = selectedNode.attrs;
        if (modals.isModalOpen(audioModals.replace)) {
          modals.closeModal(audioModals.replace);
        } else {
          const componentProps = {
            componentData: selectedNode.attrs,
            nodeId: id,
            handleFileSelection: config.handleFileSelection,
            handleFileUpload: config.handleFileUpload,
            fetchData: config.fetchData,
            embedType: src.url,
            modalId: audioModals.replace
          };
          modals?.openModal({
            id: audioModals.replace,
            Component: InsertModal,
            componentProps,
            withTransition: true,
            noPadding: true,
            type: "exclusive",
            layout: isMobile2 ? "fullscreen" : "floating",
            positioning: {
              referenceElement,
              placement: "bottom"
            },
            enableDrag: !isMobile2,
            dragHandleSelector: "[data-drag-handler]"
          });
        }
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE
    }
  ];
};
export {
  getToolbarButtons
};
//# sourceMappingURL=getToolbarButtons.js.map
